require("./aggregatorAddEntityOldModal.scss");

// @vendors
import React from "react";
import PropTypes from "prop-types";

// @constants
import { OKCheckbox } from "commonsComponents/OKCheckbox";
import { CHECK_BOX_CHECKED } from "constants/aggregator/aggregatorAddEntityModal.constants";

// @components
const OKModal = require("components/commons/OKModal/OKModal");
const modalHeaderImg = require("assets/images/referrals-preview-logo.png");
const ModalContent = require("../modalContent/modalContent");

// @utilities
const { FormattedText } = require("core/i18n").i18n;

class AggregatorAddEntityOldModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            [CHECK_BOX_CHECKED]: false,
        };
    }

    handleOnTermsChange = (checkableBox) => {
        this.setState((currState) => ({
            [checkableBox]: !currState[checkableBox],
        }));
    }

    render() {
        const { checkboxChecked } = this.state;
        const { immAggregatorAddEntity, onRequestClose, showModal } = this.props;

        const contentFooter = !immAggregatorAddEntity.get(
            "termsAndConditionsError"
        ) ? (
            <div className="aggregator-add-entity-modal__checkbox">
                <OKCheckbox
                    idName="aggregator-terms"
                    onChange={() => this.handleOnTermsChange(CHECK_BOX_CHECKED)}
                    label={
                        <FormattedText value="aggregatorAddEntityModal-termsCheckbox" />
                    }
                    value={checkboxChecked}
                />
            </div>
        ) : null;

        return (
            <OKModal
                content={<ModalContent hasError={immAggregatorAddEntity.get("termsAndConditionsError")}/>}
                contentFooter={contentFooter}
                footerType="navigation"
                headerAlignment="left"
                headerContent={modalHeaderImg}
                headerImageWidth="250px"
                headerType="image"
                isOpen={showModal}
                onCloseCallback={onRequestClose}
                onPrimaryButtonClick={() =>
                    this.props.onHandleTermsAndConditionsButton(this.state)
                }
                primaryButtonDisabled={!checkboxChecked}
                primaryButtonText="aggregatorAddEntityModal-acceptButton"
                primaryButtonLoading={immAggregatorAddEntity.get(
                    "termsAndConditionsFetch"
                )}
                size="large"
                title="aggregatorAddEntityModal-termsTitle"
            />
        );
    }
}

AggregatorAddEntityOldModal.defaultProps = {
    showModal: true,
}

AggregatorAddEntityOldModal.propTypes = {
    showModal: PropTypes.bool,
    immAggregatorAddEntity: PropTypes.object,
    onHandleTermsAndConditionsButton: PropTypes.func,
    onRequestClose: PropTypes.func,
};

export { AggregatorAddEntityOldModal };
